import { CountBySeaStatusModel } from "entities/SeaSavedCard/model/types";
import { SeaStatusesModel } from "entities/shared/seaCard.types";
import { FilterContextType, SeaFilterType, SetSeaFilterFunc } from "features/shared/filter.types";
import { AirFilterType } from "features/shared/filter.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { useSeaQueryKey } from "features/shared/useSeaQueryKey";
import { SeaWhereQuery, useSeaInfiniteScrollFetch } from "entities/SeaSavedCard";
import { ValueOf } from "shared/lib/typeCheck.lib";

type UseSeaStatusFilterProps = {
  setFilter?: SetSeaFilterFunc;
  innerFilterState: FilterContextType["innerFilterState"];
  isSeaFilter?: (filter: SeaFilterType | AirFilterType) => filter is SeaFilterType;
};

type UseSeaStatusFilterReturnType = {
  seaStatuses: CountBySeaStatusModel[];
  seaHandleFilter: (status: ValueOf<typeof SeaStatusesModel>) => void;
};

export const useSeaStatusFilter = ({
  setFilter,
  innerFilterState,
  isSeaFilter,
}: UseSeaStatusFilterProps): UseSeaStatusFilterReturnType => {
  const { isCurrentViewFilteredCards, isCurrentViewMain, showFilteredCardsView } = usePanelViews();
  const { queryKey } = useSeaQueryKey({
    isCurrentViewFilteredCards,
    isCurrentViewMain,
  });

  const { countBySeaStatus: countByStatus } = useSeaInfiniteScrollFetch({
    queryKey: [queryKey],
    shouldRequestOnMount: false,
  });

  const handleFilter = (status: ValueOf<typeof SeaStatusesModel>) => {
    if (isSeaFilter?.(innerFilterState.filter)) {
      innerFilterState.setWhereQuery((prev: SeaWhereQuery) => ({
        ...prev,
        status: status,
      }));
      setFilter?.({ ...innerFilterState.filter, where: { ...innerFilterState.filter.where, status: status } });
    }
    if (!isCurrentViewFilteredCards) {
      showFilteredCardsView();
    }
  };

  return { seaStatuses: countByStatus, seaHandleFilter: handleFilter };
};
